import { Box, Container, Grid, Typography } from "@mui/material";
import aiProtocolIcon from "../../assets/ai-protocol.svg";
import blockchainIcon from "../../assets/blockchain.svg";
import marketingIcon from "../../assets/marketing.svg";
import businessIcon from "../../assets/business.svg";

const ExpertiseCard = ({ icon, title, features }) => (
  <Box
    sx={{
      p: 2,
      height: "100%",
      border: "1px solid",
      borderColor: "rgba(13, 71, 255, 0.1)",
    }}
  >
    <Box
      component="img"
      src={icon}
      alt={title}
      sx={{
        width: 48,
        height: 48,
        mb: 3,
      }}
    />
    <Typography
      variant="h5"
      sx={{
        fontSize: "20px",
        fontWeight: 600,
        mb: 4,
      }}
    >
      {title}
    </Typography>
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {features.map((feature, index) => (
        <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              color: "#0D47FF",
              fontSize: "14px",
            }}
          >
            ✦
          </Box>
          <Typography sx={{ fontSize: "14px" }}>{feature}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

const Expertise = () => {
  const expertiseData = [
    {
      icon: aiProtocolIcon,
      title: "AI-Enhanced DeFi Protocols",
      features: [
        "AI-Powered Lending & Borrowing",
        "Yield Optimization Algorithms",
        "Predictive Analytics for Market Movements",
        "Governance AI Agents",
      ],
    },
    {
      icon: blockchainIcon,
      title: "Blockchain & On-Chain Protocol Execution",
      features: [
        "Money Markets",
        "Staking Protocols",
        "Yield Optimization",
        "Cross-Chain Integrations",
      ],
    },
    {
      icon: marketingIcon,
      title: "AI-Powered Marketing & Growth Strategies",
      features: [
        "AI-Powered Community Growth",
        "Predictive Marketing Campaigns",
        "Automated Content & SEO Optimization",
        "Data-Driven Analytics for Growth",
      ],
    },
    {
      icon: businessIcon,
      title: "AI-Driven Business & Operations",
      features: [
        "Automated Treasury & Risk Management",
        "Smart Compliance & Security",
        "AI Governance & DAO Insights",
        "Real-Time Analytics Dashboards",
      ],
    },
  ];

  return (
    <Box sx={{ py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "32px", md: "48px" },
            fontWeight: 400,
            mb: { xs: 6, md: 8 },
          }}
        >
          Our Expertise & AI-Powered Innovation
        </Typography>

        <Grid container spacing={0}>
          {expertiseData.map((item, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <ExpertiseCard {...item} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Expertise;
